<template>
  <div>
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="user.roles[0].id == 1" :to="{ path: '/home' }">
          {{ $t("home") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>mcash{{ $t("yhgl") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("yhrzxx") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="cont">
      <h2>{{ $t("yhdh") }}: {{ phone }}</h2>

      <el-form :model="form" label-width="150px" class="formbox">
        <el-form-item :label="$t('fullName')">
          <el-input v-model="form.fullName" disabled />
        </el-form-item>

        <el-form-item :label="$t('idNumber')">
          <el-input v-model="form.idNumber" disabled />
        </el-form-item>

        <el-form-item :label="$t('gender')">
          <el-input v-model="form.gender" disabled />
        </el-form-item>

        <el-form-item :label="$t('email')">
          <el-input v-model="form.email" disabled />
        </el-form-item>

        <el-form-item :label="$t('birthday')">
          <el-input v-model="form.birthday" disabled />
        </el-form-item>

        <el-form-item :label="$t('workingYearName')">
          <el-input v-model="form.workingYearName" disabled />
        </el-form-item>

        <el-form-item :label="$t('monthlySalaryName')">
          <el-input v-model="form.monthlySalaryName" disabled />
        </el-form-item>

        <el-form-item :label="$t('workingDaysName')">
          <el-input v-model="form.workingDaysName" disabled />
        </el-form-item>

        <!-- 图片 -->
        <el-form-item :label="$t('idCardPositive')">
          <el-image
            :src="form.idCardPositive"
            :preview-src-list="imgList"
            :key="imgKey"
            style="width: 200px"
          />
        </el-form-item>

        <el-form-item :label="$t('idCardReverse')">
          <el-image
            :src="form.idCardReverse"
            :preview-src-list="imgList"
            :key="imgKey"
            style="width: 200px"
          />
        </el-form-item>

        <el-form-item :label="$t('faceUrl')">
          <el-image
            :src="form.faceUrl"
            :preview-src-list="imgList"
            :key="imgKey"
            style="width: 200px"
          />
        </el-form-item>

        <!-- 审核按钮 -->
        <el-form-item>
          <el-button v-if="form.faceUrl != null && form.idNumber != null" type="success" @click="submitAudit(1)">通过</el-button>
          <el-button v-if="form.faceUrl != null" type="danger" @click="submitAudit(2)">拒绝</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import apiurl from "@/api/public";
import _api from "@/api/index";

export default {
  data() {
    return {
      user: {},
      phone: "",
      imgKey: Date.now(),
      form: {
        id: "",
        fullName: "",
        idNumber: "",
        gender: "",
        email: "",
        birthday: "",
        workingYearName: "",
        monthlySalaryName: "",
        workingDaysName: "",
        idCardPositive: "",
        idCardReverse: "",
        faceUrl: "",
      },
      imgList: [],
    };
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("userinfo"));
    this.form.id = this.$route.query.id;
    this.phone = this.$route.query.phone;
    this.getDetail();
  },

  methods: {
    getDetail() {
      _api.get(apiurl.userInfo, { userId: this.form.id }).then((res) => {
        Object.assign(this.form, res.data);
        // 图片刷新关键点
        this.imgList = [
          res.data.idCardPositive,
          res.data.idCardReverse,
          res.data.faceUrl,
        ];
        this.imgKey = Date.now(); // 强制刷新 el-image
      });
    },

    submitAudit(status) {
      this.$confirm(
        status === 1 ? "确认通过该用户认证？" : "确认拒绝该用户认证？",
        "提示",
        { type: "warning" }
      ).then(() => {
        _api
          .post(apiurl.userAuthAudit, {
            id: this.form.id,
            status: status,
            faceUrl: this.form.faceUrl,
          })
          .then(() => {
            this.$message.success("操作成功");
            this.$router.back();
          });
      });
    },
  },
};
</script>
<style scoped>
.formbox {
  padding: 15px 0;
  width: 700px;
}
</style>
